/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_Description_LabelInputs */

const en_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please describe the content in your own words`)
};

const fr_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez décrire le contenu avec vos propres mots.`)
};

const de_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte beschreiben Sie den Inhalt in Ihren eigenen Worten.`)
};

const it_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrivi il contenuto con parole tue.`)
};

const ru_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, опишите содержание своими словами.`)
};

const es_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, describe el contenido con tus propias palabras.`)
};

const zh_cn2_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请用您自己的话描述内容。`)
};

const ja_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容をあなた自身の言葉で説明してください。`)
};

const hi_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया विषयवस्तु का वर्णन अपने शब्दों में करें।`)
};

const pt_pt2_content_description_label = /** @type {(inputs: Content_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, descreva o conteúdo com suas próprias palavras.`)
};

/**
* | output |
* | --- |
* | "Please describe the content in your own words" |
*
* @param {Content_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const content_description_label = /** @type {((inputs?: Content_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_content_description_label(inputs)
	if (locale === "de") return de_content_description_label(inputs)
	if (locale === "it") return it_content_description_label(inputs)
	if (locale === "ru") return ru_content_description_label(inputs)
	if (locale === "es") return es_content_description_label(inputs)
	if (locale === "zh-CN") return zh_cn2_content_description_label(inputs)
	if (locale === "ja") return ja_content_description_label(inputs)
	if (locale === "hi") return hi_content_description_label(inputs)
	if (locale === "pt-PT") return pt_pt2_content_description_label(inputs)
	return en_content_description_label(inputs)
});